import React, { useState, useEffect } from "react";
import axios from "axios";
import { RxCrossCircled } from "react-icons/rx";

const AddAddressModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    user: "",
    fullName: "",
    phone: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
    landmark: "",
    addressType: "Home",
    isDefault: true,
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const storedData = JSON.parse(
      localStorage.getItem("BricksNbar-Users-Data")
    );
    if (storedData?._id) {
      setFormData((prev) => ({
        ...prev,
        user: storedData._id,
        fullName: `${storedData.firstName?.trim() || ""} ${
          storedData.lastName?.trim() || ""
        }`,
        phone: storedData.phone || "",
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await axios.post(
        "https://bricknbar-ecom-sv0x.onrender.com/bricks-n-bar/address/create-address",
        formData,
        { headers: { "Content-Type": "application/json" } }
      );
      setMessage("Address added successfully!");
      console.log(response.data);
      onClose(); // Close modal after success
    } catch (error) {
      console.error(error);
      setMessage("Failed to add address.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-xl p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-7 right-7 text-gray-500 hover:text-red-500 text-xl"
        >
          <RxCrossCircled />
        </button>
        <h2 className="text-2xl font-semibold mb-4">Add New Address</h2>
        <form
          onSubmit={handleSubmit}
          className="space-y-4 max-h-[70vh] overflow-y-auto pr-2"
        >
          {[
            { label: "Full Name", name: "fullName" },
            { label: "Phone", name: "phone" },
            { label: "Address Line 1", name: "addressLine1" },
            { label: "Address Line 2", name: "addressLine2" },
            { label: "City", name: "city" },
            { label: "State", name: "state" },
            { label: "Postal Code", name: "postalCode" },
            { label: "Country", name: "country" },
            { label: "Landmark", name: "landmark" },
          ].map(({ label, name }) => (
            <div key={name}>
              <label className="block text-sm font-medium text-gray-700">
                {label}
              </label>
              <input
                type="text"
                name={name}
                value={formData[name]}
                onChange={handleChange}
                required={name !== "addressLine2" && name !== "landmark"}
                className="w-full mt-1 p-2 border border-gray-300 rounded-lg"
              />
            </div>
          ))}

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Address Type
            </label>
            <select
              name="addressType"
              value={formData.addressType}
              onChange={handleChange}
              className="w-full mt-1 p-2 border border-gray-300 rounded-lg"
            >
              <option value="Home">Home</option>
              <option value="Work">Work</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              name="isDefault"
              checked={formData.isDefault}
              onChange={handleChange}
              className="mr-2"
            />
            <label className="text-sm">Set as default address</label>
          </div>

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition"
            disabled={loading}
          >
            {loading ? "Saving..." : "Add Address"}
          </button>

          {message && (
            <p
              className={`mt-2 text-center ${
                message.includes("success") ? "text-green-600" : "text-red-600"
              }`}
            >
              {message}
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

export default AddAddressModal;
